module.exports = __webpack_public_path__ + "img/redeem-invalid-icon.000439c7.png";